import React, { useEffect, useState, useMemo } from "react";
import {
  getClassStartTime,
  sendStartTime,
  getClassSummary,
  sendActions,
  submitZoomLinkForClassStart,
  submitClassCancelReasons,
  submitEvaluationReport,
  uploadVideoinTopics,
  updatePlannerDataFunc,
  updateTimeTable,
  getAllChapters,
  updatePlannerEndpoint,
} from "../../../actions/tutorFeedActions";
import { connect } from "react-redux";
import { uploadWorksheet } from "../../../actions/feedActions";
import { Media } from "reactstrap";
import { Link } from "react-router-dom";
import $ from "jquery";
import yTubeIcon from "../../../public/images/youtubeIcon.svg";
import worksheetIcon from "../../../public/images/google-docs.png";
import MyToolTip from "../../ReuseComponenets/MyToolTip";
import DemoStudentEvaluation from "../ClassEvaluation/DemoStudentEvaluation";
import moment from "moment";
import UploadVideo from "../../website/tutorViews/uploadVideo/UploadVideo";
import UploadWorksheet from "../../website/tutorViews/uploadWorksheet/UploadWorksheet";
import Simulator from "./Simulator";
import SendTopicsStartsClass from "./SendTopicsStartClass";
import ChangeTime from "./ChangeTime";
import "./classStart.scss";
import UpdatePlanner from "./UpdatePlanner";

function ClassStart3(props) {
  const [timeLeft, setTimeLeft] = useState();
  const [startButton, setstartButton] = useState(true);
  const [programNameState, setprogramNameState] = useState();
  const [classStartData, setclassStartData] = useState("");
  const [count, setcount] = useState(true);
  const [programId, setprogramId] = useState("");
  const [slotId, setslotId] = useState("");
  const [courseId, setcourseId] = useState("");
  const [timeStampHistory, settimeStampHistory] = useState([]);
  const [classesInfo, setclassesInfo] = useState([]);
  const [overAllSummary, setoverAllSummary] = useState("");
  const [timeSummary, settimeSummary] = useState([]);
  const [makingArray, setmakingArray] = useState({
    1: 2,
    2: 2,
    3: 2,
    4: 2,
  });
  const [filter, setfilter] = useState("month");
  const [loading, setloading] = useState(true);
  const [apiError, setapiError] = useState("");
  const [alreadystartError, setalreadystartError] = useState("");
  const [zoomLink, setzoomLink] = useState(null);
  const [timeOver, settimeOver] = useState(false);
  const [postBtnClicked, setpostBtnClicked] = useState(false);
  const [classCancelReasons, setclassCancelReasons] = useState([]);
  const [teacherId, setteacherId] = useState("");
  const [studentsArray, setstudentsArray] = useState([]);
  const [snackbarMessage, setsnackbarMessage] = useState("");
  const [snackbarColor, setsnackbarColor] = useState("#01ac8a");
  const [snackbar, setsnackbar] = useState(false);
  const [btnLoader, setbtnLoader] = useState(false);
  const [copied, setcopied] = useState(false);
  const [openVideoModal, setopenVideoModal] = useState(false);
  const [openWorksheetModal, setopenWorksheetModal] = useState(false);
  const [reasonSelect, setreasonSelect] = useState(false);
  const [plannerData, setplannerData] = useState([]);
  const [updatedPlannerData, setupdatedPlannerData] = useState([]);
  const [selectedPlannerTopic, setselectedPlannerTopic] = useState([]);
  const [plannerId, setplannerId] = useState("");
  const [submitLoading, setsubmitLoading] = useState(false);
  const [snackColor, setsnackColor] = useState("");
  const [disableButton, setdisableButton] = useState(false);
  const [alreadySubmitted, setalreadySubmitted] = useState(true);
  const [evaluationData, setevaluationData] = useState([]);
  const [attendanceData, setattendanceData] = useState([]);
  const [simulatorBtn, setsimulatorBtn] = useState(false);
  const [chapterId, setchapterId] = useState("");
  const [topicId, settopicId] = useState("");
  const [worksheetLabel, setworksheetLabel] = useState("");
  const [worksheetId, setworksheetId] = useState("");
  const [VideoId, setVideoId] = useState("");
  const [VideoLabel, setVideoLabel] = useState("");
  const [videoUrl, setvideoUrl] = useState("");
  const [classTime, setclassTime] = useState("");
  const [plannerDataForHistory, setplannerDataForHistory] = useState("");
  const [plannerTimeStamp, setplannerTimeStamp] = useState("");
  const [classTimeTable, setclassTimeTable] = useState("");
  const [updatePlannerLoader, setupdatePlannerLoader] = useState(false);

  const calculateTimeLeft = (time) => {
    const difference = +new Date(time) - +new Date();
    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        d: Math.floor(difference / (1000 * 60 * 60 * 24)),
        h: Math.floor((difference / (1000 * 60 * 60)) % 24),
        m: Math.floor((difference / 1000 / 60) % 60),
        s: Math.floor((difference / 1000) % 60),
      };
      return timeLeft;
    }
    else {
      setstartButton(false);
      return timeLeft;
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      const newTimeLeft = calculateTimeLeft(classStartData.datetime);
      setTimeLeft(newTimeLeft);

      if (newTimeLeft.d === 0 && newTimeLeft.h === 0 && newTimeLeft.m <= 10 && count) {
        setstartButton(false);
        setcount(false);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [classStartData.datetime, count]);

  if (props.programNameState.programName !== programNameState) {
    const { programNameState, attendanceData } = props;
    debugger;
    setsimulatorBtn(false);
    setapiError("");
    setevaluationData([]);
    setattendanceData([]);
    setplannerData([]);
    setselectedPlannerTopic([]);
    setloading(true);
    setprogramNameState(programNameState.programName);
    setprogramId(programNameState.program);
    setslotId(programNameState.slotId);
    setcourseId(programNameState.courseId);
    setcount(true);
    setstartButton(true);

    props.getAllChapters(programNameState.program);

    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    if (tutorData != null) {
      setteacherId(tutorData.user.id);
      setstudentsArray(tutorData.teacher_students[programNameState.programName]);

      //To Get Students Logic
      let TeacherStudent = tutorData.teacher_students;

      if (typeof TeacherStudent[programNameState.programName] != "undefined") {
        debugger;
        let mapOver = [];
        var countNull = 0;
        var a = TeacherStudent[programNameState.programName].map((item, index) => {
          mapOver.push({
            isPresent: 0,
            id: item.student_id,
            name: item.user_name,
            image: item.image,
            onTime: "",
            attentive: "",
            homeworkCompletion: "",
            classworkCompletion: "",
            is_expired: item.is_expired,
            is_scheduled_demo: item.is_scheduled_demo,
            course_id: item.course_id,
            is_customized: item.is_customized,
            slot_id: item.slot_id,
            prog_id: item.prog_id,
          });
        });
        console.log("MAP OVER", mapOver);
        setevaluationData(mapOver);
      }

      //To get Class Start Time
      props
        .getClassStartTime(
          programNameState.program,
          tutorData.user.id,
          programNameState.courseId,
          tutorData.user.client_id,
          programNameState.slotId,
          moment().format("MMMM"),
          moment().year()
        )
        .then((res) => {
          if (res.status == "success" && typeof res.message === "undefined") {
            setclassStartData(res.result);
            setcount(true);
            setstartButton(true);
            debugger;
            calculateTimeLeft(res.result.datetime);
            setloading(false);
            setzoomLink(res.zoomlink);
            setattendanceData(res.attendacne);
            setclassTimeTable(convertToArrayOfObjects(JSON.parse(res.timetable)));
            if (res.planner_data) {
              debugger;
              setplannerId(res.planner_data.planner_id);
              setplannerData(res.planner_data.week_data);
              setupdatedPlannerData(res.planner_data.week_data);
            }
          } else if (res.status == "success" && typeof res.message !== "undefined") {
            debugger;
            setsimulatorBtn(true);
            // setclassTimeTable(convertToArrayOfObjects(JSON.parse(res.timetable)));
            setattendanceData(res.attendacne);
            if (res.planner_data) {
              setplannerId(res.planner_data.planner_id);
              setplannerData(res.planner_data.week_data);
              setupdatedPlannerData(res.planner_data.week_data);
            }
            setapiError(res.message);
            setloading(false);
          } else {
            debugger;
            setloading(false);
            setapiError(res.message);
          }
        })
        .catch((err) => {
          debugger;
          if (err.data.status == "error") {
            debugger;
          }
        });

      //To get Summary and All
      props
        .getClassSummary(
          programNameState.program,
          tutorData.user.id,
          programNameState.courseId,
          filter,
          programNameState.slotId
        )
        .then((res) => {
          if (res.status == "success") {
            settimeStampHistory(res.result["timeStampHistory"]);
            setclassesInfo(res.result["timeStampHistory"]);
            // settimeSummary(res.result['timeStampSummary']);
            // setoverAllSummary(res.result['overAllSummary']);
            console.log("API", res.result);

            var overAllSummaryMapped = res.result["overAllSummary"].map((item) => ({
              [item.label]: item.count,
            }));

            setoverAllSummary(Object.assign({}, ...overAllSummaryMapped));

            setmakingArray({
              ...makingArray,
              ...res.result["timeStampSummary"],
            });
            var timeStampSummaryMapped = res.result["timeStampSummary"].map((item) => ({
              [item.label]: item.count,
            }));
            console.log("MAPPED", timeStampSummaryMapped);
            settimeSummary(Object.assign({}, ...timeStampSummaryMapped));
            debugger;
          } else {
            debugger;
          }
        })
        .catch((err) => {
          debugger;
          if (err.data.status == "error") {
            debugger;
          }
        });
    }
  }

  const timerComponents = useMemo(() => {
    if (timeLeft && Object.keys(timeLeft).length === 0 && postBtnClicked) {
      setpostBtnClicked(false);
      window.open(zoomLink, "_blank");
      setTimeLeft({});
      $("#myModalWait").modal("hide");
      return [];
    }

    return (
      timeLeft &&
      Object.keys(timeLeft).map((interval) => {
        if (!timeLeft[interval]) {
          return null;
        }
        return (
          <span key={interval} className="" style={{ fontSize: 14, color: "#78c660" }}>
            {timeLeft[interval]}
            {interval}{" "}
          </span>
        );
      })
    );
  }, [timeLeft, postBtnClicked]);

  const convertToArrayOfObjects = (obj) => {
    let arr = [];
    for (let key in obj) {
      arr.push({
        id: key,
        day: obj[key].day,
        is_on: obj[key].is_on,
        start: obj[key].start,
        end: obj[key].end,
      });
    }
    return arr;
  };

  const postTime = () => {
    const timeDifference = +new Date(classStartData.datetime) - +new Date();
    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    debugger;
    if (
      tutorData != null &&
      zoomLink != null &&
      timeDifference < 0 &&
      selectedPlannerTopic.length > 0
    ) {
      debugger;
      props
        .sendStartTime(
          programId,
          tutorData.user.id,
          courseId,
          props.programNameState.slotId,
          plannerId,
          selectedPlannerTopic
        )
        .then((res) => {
          debugger;
          setapiError("Class Started");
          window.open(zoomLink, "_blank");
          props
            .getClassSummary(programId, tutorData.user.id, courseId, filter, slotId)
            .then((res2) => {
              if (res2.status == "success") {
                settimeStampHistory(res2.result["timeStampHistory"]);
                setclassesInfo(res2.result["timeStampHistory"]);
                debugger;
              } else {
                debugger;
              }
            })
            .catch((err) => {
              debugger;
              if (err.data.status == "error") {
                debugger;
              }
            });
        })
        .catch((err) => {
          debugger;
        });
    } else if (
      tutorData != null &&
      zoomLink != null &&
      timeDifference > 0 &&
      selectedPlannerTopic.length > 0
    ) {
      debugger;
      setpostBtnClicked(true);
      props
        .sendStartTime(
          programId,
          tutorData.user.id,
          courseId,
          props.programNameState.slotId,
          plannerId,
          selectedPlannerTopic
        )
        .then((res) => {
          debugger;
          setapiError("Class Started");
          // window.open(zoomLink, '_blank');
          props
            .getClassSummary(programId, tutorData.user.id, courseId, filter, slotId)
            .then((res2) => {
              if (res2.status == "success") {
                settimeStampHistory(res2.result["timeStampHistory"]);
                setclassesInfo(res2.result["timeStampHistory"]);
                debugger;
              } else {
                debugger;
              }
            })
            .catch((err) => {
              debugger;
              if (err.data.status == "error") {
                debugger;
              }
            });
        })
        .catch((err) => {
          debugger;
        });
      $("#myModalWait").modal("show");
    } else if (
      tutorData != null &&
      zoomLink != null &&
      (timeDifference < 0 || timeDifference > 0) &&
      selectedPlannerTopic.length == 0
    ) {
      $("#myModalConfirm").modal("show");
    } else {
      debugger;
      $("#myModal").modal("show");
    }
  };
  const postTimeWithoutTopics = () => {
    const timeDifference = +new Date(classStartData.datetime) - +new Date();
    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    debugger;
    if (tutorData != null && zoomLink != null && timeDifference < 0) {
      debugger;
      props
        .sendStartTime(
          programId,
          tutorData.user.id,
          courseId,
          props.programNameState.slotId,
          plannerId,
          selectedPlannerTopic
        )
        .then((res) => {
          debugger;
          setapiError("Class Started");
          window.open(zoomLink, "_blank");
          props
            .getClassSummary(programId, tutorData.user.id, courseId, filter, slotId)
            .then((res2) => {
              if (res2.status == "success") {
                settimeStampHistory(res2.result["timeStampHistory"]);
                setclassesInfo(res2.result["timeStampHistory"]);
                debugger;
              } else {
                debugger;
              }
            })
            .catch((err) => {
              debugger;
              if (err.data.status == "error") {
                debugger;
              }
            });
        })
        .catch((err) => {
          debugger;
        });
    } else if (tutorData != null && zoomLink != null && timeDifference > 0) {
      debugger;
      setpostBtnClicked(true);
      props
        .sendStartTime(
          programId,
          tutorData.user.id,
          courseId,
          props.programNameState.slotId,
          plannerId,
          selectedPlannerTopic
        )
        .then((res) => {
          debugger;
          setapiError("Class Started");
          // window.open(zoomLink, '_blank');
          props
            .getClassSummary(programId, tutorData.user.id, courseId, filter, slotId)
            .then((res2) => {
              if (res2.status == "success") {
                settimeStampHistory(res2.result["timeStampHistory"]);
                setclassesInfo(res2.result["timeStampHistory"]);
                debugger;
              } else {
                debugger;
              }
            })
            .catch((err) => {
              debugger;
              if (err.data.status == "error") {
                debugger;
              }
            });
        })
        .catch((err) => {
          debugger;
        });
      $("#myModalWait").modal("show");
    }
  };

  const submitPlannerHistory = (data) => {
    debugger;
    props
      .updatePlannerDataFunc(
        programId,
        teacherId,
        courseId,
        slotId,
        plannerId,
        plannerTimeStamp,
        JSON.stringify(data)
      )
      .then((res) => {
        setsnackbarMessage("Topic Sent Successfully");
        setsnackbar(true);
        setsubmitLoading(false);
        setTimeout(() => {
          window.location.reload();
          setsnackbar(false);
          setsnackColor("#01ac8a");
        }, 2000);
      });
  };

  const takeAction = (itemId, action) => {
    // $('#myModal').modal('show');
    var filter = classesInfo.filter((item) => item.time_id !== itemId);
    timeStampHistory.map((item, index) => {
      debugger;
      if (timeStampHistory[index]["time_id"] === itemId) {
        debugger;
        timeStampHistory[index]["label"] = action;
      }
    });
    timeSummary[action] = +timeSummary[action] + 1;
    debugger;
    setclassesInfo(filter);
  };

  const doFiler = (e, itemId) => {
    // var filter = classesInfo.filter(item => item.time_id !== itemId);
    timeStampHistory.map((item, index) => {
      debugger;
      if (timeStampHistory[index]["time_id"] === itemId) {
        debugger;
        timeStampHistory[index]["label"] = parseInt(e.target.value);
      }
    });

    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    if (tutorData != null) {
      props
        .sendActions(programId, tutorData.user.id, courseId, itemId, e.target.value)
        .then((res) => {
          debugger;
          props
            .getClassSummary(programId, tutorData.user.id, courseId, filter, slotId)
            .then((res2) => {
              if (res2.status == "success") {
                settimeStampHistory(res2.result["timeStampHistory"]);
                setclassesInfo(res2.result["timeStampHistory"]);
                var overAllSummaryMapped = res2.result["overAllSummary"].map((item) => ({
                  [item.label]: item.count,
                }));

                setoverAllSummary(Object.assign({}, ...overAllSummaryMapped));

                setmakingArray({
                  ...makingArray,
                  ...res2.result["timeStampSummary"],
                });
                var timeStampSummaryMapped = res2.result["timeStampSummary"].map((item) => ({
                  [item.label]: item.count,
                }));
                console.log("MAPPED", timeStampSummaryMapped);
                settimeSummary(Object.assign({}, ...timeStampSummaryMapped));
                debugger;
              } else {
                debugger;
              }
            })
            .catch((err) => {
              debugger;
              if (err.data.status == "error") {
                debugger;
              }
            });
        })
        .catch((err) => {
          debugger;
        });
    }
    // timeSummary[parseInt(e.target.value)] = +timeSummary[parseInt(e.target.value)] + 1;
    debugger;
    // setclassesInfo(filter);
    settimeStampHistory([...timeStampHistory]);
  };

  const submitZoom = () => {
    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    if (tutorData != null) {
      props
        .submitZoomLinkForClassStart(
          programId,
          tutorData.user.id,
          courseId,
          zoomLink,
          props.programNameState.slotId
        )
        .then((res) => {
          $("#myModal").modal("hide");
        });
    }
  };

  const historyFilter = (e) => {
    setfilter(e.target.value);
    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    if (tutorData != null) {
      props
        .getClassSummary(programId, tutorData.user.id, courseId, e.target.value, slotId)
        .then((res2) => {
          if (res2.status == "success") {
            settimeStampHistory(res2.result["timeStampHistory"]);
            setclassesInfo(res2.result["timeStampHistory"]);
            var overAllSummaryMapped = res2.result["overAllSummary"].map((item) => ({
              [item.label]: item.count,
            }));

            setoverAllSummary(Object.assign({}, ...overAllSummaryMapped));

            var timeStampSummaryMapped = res2.result["timeStampSummary"].map((item) => ({
              [item.label]: item.count,
            }));
            console.log("MAPPED", timeStampSummaryMapped);
            settimeSummary(Object.assign({}, ...timeStampSummaryMapped));
            debugger;
            // var result = res.result['timeStampSummary'].filter(item => item.label)
          } else {
            debugger;
          }
        })
        .catch((err) => {
          debugger;
          if (err.data.status == "error") {
            debugger;
          }
        });
    }
  };

  const addReasons = (e, key, reason) => {
    setreasonSelect(reason);
    if (reason == 2 || reason == 3) {
      setclassCancelReasons([]);
      var data = [];
      if (e.target.checked) {
        data.push({
          id: key,
          reason: e.target.value,
        });
        setclassCancelReasons([...data]);
      } else {
        var a = data.filter((item) => item.id !== key);
        setclassCancelReasons(a);
      }
    } else {
      if (e.target.checked) {
        classCancelReasons.push({
          id: key,
          reason: e.target.value,
        });
      } else {
        var a = classCancelReasons.filter((item) => item.id !== key);
        setclassCancelReasons(a);
      }
    }
  };
  const snackBarFunction = () => {
    var x = document.getElementById("snackbar");
    x.className = "show";
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 3000);
  };
  const submitReasons = () => {
    setbtnLoader(true);
    props
      .submitClassCancelReasons(programId, teacherId, classCancelReasons, studentsArray, courseId)
      .then((res) => {
        setsnackbarMessage("Class Cancel Message Sent");
        setsnackbarColor("#01ac8a");
        setsnackbar(true);
        setbtnLoader(false);
        setTimeout(function () {
          setsnackbar(false);
        }, 3000);
        $("#ModalNotTakeClass").modal("hide");
      })
      .catch((err) => {
        debugger;
      });
  };

  const updateLabelFunc = () => {
    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    uploadWorksheet(topicId, tutorData.user.id, worksheetLabel, null, null, null, worksheetId)
      .then((res) => {
        setsnackbarMessage("Label Updated");
        setsnackbar(true);
        setsubmitLoading(false);
        setTimeout(() => {
          window.location.reload();
          setsnackbar(false);
          setsnackColor("#01ac8a");
        }, 2000);
        $("#modalForUpdateLabel").modal("hide");
      })
      .catch((err) => {
        debugger;
      });
  };

  const updateVideoLabelFunc = () => {
    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    props
      .uploadVideoinTopics(chapterId, topicId, VideoLabel, videoUrl, tutorData.user.id, VideoId)
      .then((res) => {
        setsnackbarMessage("Label Updated");
        setsnackbar(true);
        setsubmitLoading(false);
        setTimeout(() => {
          window.location.reload();
          setsnackbar(false);
          setsnackColor("#01ac8a");
        }, 2000);
        $("#modalForUpdateLabelVideo").modal("hide");
      })
      .catch((err) => {
        debugger;
      });
  };

  const updateLabel = (label, data) => {
    setworksheetLabel(label.label);
    setworksheetId(label.id);
    setchapterId(data.chapterId);
    settopicId(data.topicId);
    debugger;
    $("#modalForUpdateLabel").modal("show");
  };

  const updateVideoLabel = (label, data) => {
    setVideoLabel(label.video_caption);
    setVideoId(label.video_id);
    setvideoUrl(label.video_url);
    setchapterId(data.chapterId);
    settopicId(data.topicId);
    debugger;
    $("#modalForUpdateLabelVideo").modal("show");
  };

  const changeState = (studentId, status, columnName) => {
    markAttendanceFunction(true, studentId);
    evaluationData.map((item, index) => {
      if (studentId == item.id) {
        if (columnName == "onTime" && status == true) {
          item.onTime = 1;
        } else if (columnName == "onTime" && status == false) {
          item.onTime = 0;
        } else if (columnName == "attentive" && status == true) {
          item.attentive = 1;
        } else if (columnName == "attentive" && status == false) {
          item.attentive = 0;
        } else if (columnName == "homeworkCompletion" && status == true) {
          item.homeworkCompletion = 1;
        } else if (columnName == "homeworkCompletion" && status == false) {
          item.homeworkCompletion = 0;
        } else if (columnName == "classworkCompletion" && status == true) {
          item.classworkCompletion = 1;
        } else if (columnName == "classworkCompletion" && status == false) {
          item.classworkCompletion = 0;
        }
      }
    });
    setevaluationData([...evaluationData]);
  };

  const copyZoomLink = () => {
    navigator.clipboard.writeText(zoomLink);
    setcopied(true);
    setTimeout(() => {
      setcopied(false);
    }, 2000);
  };
  const toggleVideoModal = () => setopenVideoModal(!openVideoModal);
  const toggleWorksheetModal = () => setopenWorksheetModal(!openWorksheetModal);

  const getPLannerDetails = (monthName) => {
    setloading(true);
    setplannerData([]);
    var tutorData = JSON.parse(localStorage.getItem("loginData"));
    const { programNameState } = props;
    props
      .getClassStartTime(
        programNameState.program,
        tutorData.user.id,
        programNameState.courseId,
        tutorData.user.client_id,
        programNameState.slotId,
        monthName,
        moment().year()
      )
      .then((res) => {
        if (res.status == "success" && typeof res.message === "undefined") {
          setclassStartData(res.result);
          setcount(true);
          setstartButton(true);
          debugger;
          calculateTimeLeft(res.result.datetime);
          setloading(false);
          setzoomLink(res.zoomlink);
          if (res.planner_data) {
            debugger;
            setplannerData(res.planner_data.week_data);
            setupdatedPlannerData(res.planner_data.week_data);
          }
        } else if (res.status == "success" && typeof res.message !== "undefined") {
          setapiError(res.message);
          setloading(false);
          debugger;
        } else {
          debugger;
          setloading(false);
          setapiError(res.message);
        }
      })
      .catch((err) => {
        debugger;
        if (err.data.status == "error") {
          debugger;
        }
      });
  };

  const selectedTopic = (e, topicDetails) => {
    if (e.target.checked) {
      var makeArray = {
        topicId: topicDetails.topicId,
        topicName: topicDetails.topicName,
        chapterId: topicDetails.chapterId,
        chapterName: topicDetails.chapterName,
        worksheet: [],
        videos: [],
      };
      setselectedPlannerTopic([...selectedPlannerTopic, makeArray]);
      debugger;
    } else {
      var deleteTopic = selectedPlannerTopic.filter(
        (item) => item.topicId !== topicDetails.topicId
      );
      setselectedPlannerTopic([...deleteTopic]);
      debugger;
    }
  };

  const addWorksheet = (e, worksheetDetails) => {
    if (selectedPlannerTopic.length) {
      if (e.target.checked) {
        var getWorksheet = selectedPlannerTopic.filter(
          (item) => item.topicId == worksheetDetails.topic_id
        );

        getWorksheet[0]["worksheet"].push({ ...worksheetDetails });
        setselectedPlannerTopic([...selectedPlannerTopic]);
      } else {
        var getTopic = selectedPlannerTopic.filter(
          (item) => item.topicId == worksheetDetails.topic_id
        );
        var getWorksheet = getTopic[0]["worksheet"].filter(
          (worksheetId) => worksheetId.id !== worksheetDetails.id
        );

        getTopic[0]["worksheet"] = getWorksheet;

        setselectedPlannerTopic([...selectedPlannerTopic]);
        debugger;
      }
    } else {
      alert("Select Topic first");
    }
  };

  const addVideo = (e, worksheetDetails) => {
    if (selectedPlannerTopic.length) {
      if (e.target.checked) {
        var getWorksheet = selectedPlannerTopic.filter(
          (item) => item.topicId == worksheetDetails.test_id
        );

        getWorksheet[0]["videos"].push({ ...worksheetDetails });
        setselectedPlannerTopic([...selectedPlannerTopic]);
      } else {
        var getTopic = selectedPlannerTopic.filter(
          (item) => item.topicId == worksheetDetails.test_id
        );
        var getWorksheet = getTopic[0]["videos"].filter(
          (worksheetId) => worksheetId.video_id !== worksheetDetails.video_id
        );

        getTopic[0]["videos"] = getWorksheet;

        setselectedPlannerTopic([...selectedPlannerTopic]);
        debugger;
      }
    } else {
      alert("Select Topic first");
    }
  };

  const markAttendanceFunction = (e, studentId) => {
    evaluationData.map((item) => {
      if (studentId == item.id) {
        if (e) {
          item.isPresent = 1;
        } else {
          item.isPresent = 0;
        }
      }
    });
    setevaluationData([...evaluationData]);
  };

  const submitEvaluation = (attendanceDate) => {
    setsubmitLoading(true);
    setdisableButton(true);
    props
      .submitEvaluationReport(
        2,
        teacherId,
        programId,
        programNameState,
        evaluationData,
        props.programNameState.slotId,
        attendanceDate
      )
      .then((success) => {
        debugger;
        if (success.data.status == "success") {
          setsnackbarMessage("Evaluation Added Successfully");
          setsnackbar(true);
          setsubmitLoading(false);
          setTimeout(() => {
            props.history.push("/Teacherdashboard");
            window.location.reload();
            setsnackbar(false);
            setsnackColor("#01ac8a");
          }, 2000);
        }
      })
      .catch((err) => {
        setsnackbarMessage("Evaluation Already Submitted");
        setsnackbar(true);
        setsnackColor("#ed2525");
        setTimeout(() => {
          props.history.push("/Teacherdashboard");
          window.location.reload();
          setsnackbar(false);
        }, 2000);
        debugger;
      });
  };

  const openVideoModalDetails = (data) => {
    setopenVideoModal(true);
    setchapterId(data.chapterId);
    settopicId(data.topicId);
    debugger;
  };

  const openWorksheetModalDetails = (data) => {
    setopenWorksheetModal(true);
    setchapterId(data.chapterId);
    settopicId(data.topicId);
    debugger;
  };

  const openSendMoreTopics = (data) => {
    debugger;
    setclassTime(data.timestamped);
    setplannerTimeStamp(data.ts);
    setplannerDataForHistory(data);
  };

  const getVideosCount = (data) => {
    var reduced = JSON.parse(data).planner_topic?.reduce(function (r, a) {
      return r + a.videos.length;
    }, 0);

    if (typeof reduced != "undefined" && typeof reduced != "null" && reduced != 0) {
      return reduced;
    } else return <span className="text-danger font-weight-bold">0</span>;
  };

  const getVideosCountNumber = (data) => {
    var reduced = JSON.parse(data).planner_topic?.reduce(function (r, a) {
      return r + a.videos.length;
    }, 0);

    if (typeof reduced != "undefined" && typeof reduced != "null" && reduced != 0) {
      return reduced;
    } else return 0;
  };

  const getWorksheetsCount = (data) => {
    var reduced = JSON.parse(data).planner_topic?.reduce(function (r, a) {
      return r + a.worksheet.length;
    }, 0);

    if (typeof reduced != "undefined" && typeof reduced != "null" && reduced != 0) {
      return reduced;
    } else return <span className="text-danger font-weight-bold">0</span>;
  };

  const getWorksheetsCountNumber = (data) => {
    var reduced = JSON.parse(data).planner_topic?.reduce(function (r, a) {
      return r + a.worksheet.length;
    }, 0);

    if (typeof reduced != "undefined" && typeof reduced != "null" && reduced != 0) {
      return reduced;
    } else return 0;
  };

  const changeTimeTableFunc = (activeDay, id, start, end) => {
    debugger;
    let filterData = [];
    if (activeDay) {
      filterData = classTimeTable.filter((item) => item.id === id);
      debugger;
      filterData[0]["is_on"] = activeDay;
      filterData[0]["start"] = start;
      filterData[0]["end"] = end;
      setclassTimeTable([...classTimeTable]);
    } else {
      filterData = classTimeTable.filter((item) => item.id === id);
      filterData[0]["is_on"] = activeDay;
      filterData[0]["start"] = start;
      filterData[0]["end"] = end;
      setclassTimeTable([...classTimeTable]);
    }
  };

  const updateTimeTableFunc = () => {
    setsubmitLoading(true);
    const object = {};
    classTimeTable.forEach((item) => {
      object[item.id] = item;
    });
    debugger;
    props.updateTimeTable(teacherId, slotId, JSON.stringify(object)).then((res) => {
      debugger;
      if (res.status === "success") {
        $("#popupForChangeTime").modal("hide");
        $("#timeTableUpdated").modal("show");
        setsubmitLoading(false);
      }
    });
    console.log("Reverse Object", object);
  };

  const updatePlannerFunc = () => {
    debugger;
    setupdatePlannerLoader(true);
    props.updatePlannerEndpoint(plannerId, updatedPlannerData).then((res) => {
      var tutorData = JSON.parse(localStorage.getItem("loginData"));
      const { programNameState } = props;
      props
        .getClassStartTime(
          programNameState.program,
          tutorData.user.id,
          programNameState.courseId,
          tutorData.user.client_id,
          programNameState.slotId,
          moment().format("MMMM"),
          moment().year()
        )
        .then((res) => {
          if (res.status == "success" && typeof res.message === "undefined") {
            setupdatePlannerLoader(false);
            setclassStartData(res.result);
            setcount(true);
            setstartButton(true);
            debugger;
            calculateTimeLeft(res.result.datetime);
            setloading(false);
            setzoomLink(res.zoomlink);
            if (res.planner_data) {
              debugger;
              setplannerData(res.planner_data.week_data);
              setupdatedPlannerData(res.planner_data.week_data);
            }

            //For PlannerUpdate Accordion
            const accordionClass = document.getElementById("openAccordion");
            accordionClass.classList.remove("show");
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            setsnackbarMessage("Planner Updated Successfully");
            setsnackbar(true);
            setsnackColor("#ed2525");
            setTimeout(() => {
              setsnackbar(false);
            }, 2000);
          } else if (res.status == "success" && typeof res.message !== "undefined") {
            setapiError(res.message);
            setloading(false);
            setupdatePlannerLoader(false);
            debugger;
          } else {
            debugger;
            setloading(false);
            setapiError(res.message);
            setupdatePlannerLoader(false);
          }
        })
        .catch((err) => {
          debugger;
          if (err.data.status == "error") {
            debugger;
            setupdatePlannerLoader(false);
          }
        });
    });
  };

  console.log("Planner Data", plannerData);
  console.log("updatedPlannerData", updatedPlannerData);
  // console.log("Selected Planner Data", selectedPlannerTopic);
  // console.log("evaluationData", evaluationData);
  // console.log("Attendance Data", attendanceData);
  // console.log("classCancelReasons", classCancelReasons);
  // console.log("timeStampHistory", timeStampHistory);
  // console.log("Class Time Table", classTimeTable);
  return (
    // We are using this component for Class Start
    <div className="classStart">
      <div
        className={snackbar ? "show" : ""}
        id="snackbar"
        style={{ backgroundColor: snackbarColor }}
      >
        {snackbarMessage}
      </div>
      <UploadVideo
        open={openVideoModal}
        toggleVideoModal={toggleVideoModal}
        testId={topicId}
        assementId={chapterId}
        teacherId={teacherId}
      />{" "}
      <UploadWorksheet
        isOpen={openWorksheetModal}
        toggleWorksheetModal={toggleWorksheetModal}
        testId={topicId}
        worksheetFiles={[]}
        worksheetUrls={[]}
      />{" "}
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div
              className={
                selectedPlannerTopic.length > 0
                  ? "col-md-8 smoothTransition"
                  : "col-md-12 smoothTransition"
              }
            >
              <div className="modalForZoomLink">
                <div class="modal fade" tabindex="-1" role="dialog" id="timeTableUpdated">
                  <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                      <div class="modal-body">
                        <div className="text-center">
                          <i className="fas fa-check-circle-o mr-3 fa-4x text-success"></i>
                          <h5 className="font-weight-bold mt-3">
                            Your time table has been updated!
                          </h5>
                          <br />
                          <p> (you can change it again whenever you want) </p>
                        </div>
                        <div className="text-center">
                          <button
                            className="btn btn-success btn-block"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={() => window.location.reload()}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modalForZoomLink">
                <div class="modal fade" tabindex="-1" role="dialog" id="myModal">
                  <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                      <div class="">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div className="text-center">
                          <label className="font-weight-bold">
                            <i className="fas fa-link mr-3"></i>Paste Zoom Link here{" "}
                          </label>
                          <input
                            type="text"
                            value={zoomLink}
                            className="form-control"
                            onChange={(e) => setzoomLink(e.target.value)}
                          ></input>
                        </div>
                        <div className="text-center justify-content-center">
                          <button
                            className="btn btn-lg modalSubmitBtn"
                            onClick={() => submitZoom()}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                      {/* <div class="modal-footer">
                                                <button type="button" class="btn btn-primary" onClick={() => doFiler(43, 3)}>Save changes</button>
                                            </div> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="modalForZoomLink">
                <div class="modal fade" tabindex="-1" role="dialog" id="modalForUpdateLabel">
                  <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                      <div class="">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div className="text-center">
                          <label className="font-weight-bold">
                            <i className="fas fa-link mr-3"></i>Write new label for the worksheet
                          </label>
                          <input
                            type="text"
                            value={worksheetLabel}
                            className="form-control"
                            onChange={(e) => setworksheetLabel(e.target.value)}
                          ></input>
                        </div>
                        <div className="text-center justify-content-center">
                          <button
                            className="btn btn-lg modalSubmitBtn"
                            onClick={() => updateLabelFunc()}
                          >
                            Update Label
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modalForZoomLink">
                <div class="modal fade" tabindex="-1" role="dialog" id="modalForUpdateLabelVideo">
                  <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                      <div class="">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div className="text-center">
                          <label className="font-weight-bold">
                            <i className="fas fa-link mr-3"></i>Write new label for the video
                          </label>
                          <input
                            type="text"
                            value={VideoLabel}
                            className="form-control"
                            onChange={(e) => setVideoLabel(e.target.value)}
                          ></input>
                        </div>
                        <div className="text-center justify-content-center">
                          <button
                            className="btn btn-lg modalSubmitBtn"
                            onClick={() => updateVideoLabelFunc()}
                          >
                            Update Label
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modalForZoomLink">
                <div
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  id="myModalWait"
                  data-backdrop="static"
                  data-keyboard="false"
                >
                  <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                      <div class="modal-body">
                        <div className="text-center">
                          <label className="" style={{ fontSize: 18 }}>
                            Class will be intitiated in{" "}
                          </label>
                          <br />
                          {timerComponents}
                        </div>
                        <div className="text-center mt-5">
                          <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                        <div className="text-center justify-content-center mt-5 text-danger font-weight-bold">
                          <label>Do not close this window</label>
                        </div>
                      </div>
                      {/* <div class="modal-footer">
                                                <button type="button" class="btn btn-primary" onClick={() => doFiler(43, 3)}>Save changes</button>
                                            </div> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="modalForZoomLink">
                <div
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  id="myModalConfirm"
                  data-backdrop="static"
                  data-keyboard="false"
                >
                  <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                      <div class="modal-body">
                        <div className="text-center">
                          <label className="" style={{ fontSize: 18 }}>
                            You have not selected a topic(s) from the planner
                          </label>
                        </div>
                        <div className="text-center mt-5">
                          <button onClick={postTimeWithoutTopics} className="btn btn-success mr-3">
                            Start Class anyway
                          </button>
                          <button className="btn btn-danger ml-3" data-dismiss="modal">
                            Add topic
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modalForZoomLink">
                <div class="modal fade" tabindex="-1" role="dialog" id="popupForChangeTime">
                  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                      <div className="d-flex justify-content-between">
                        <h5 className="mb-4 p-2">Change the Start and End Class Timings</h5>
                        <div className="d-flex">
                          {/* <p className="mb-4 p-2">The time is according to (GMT+5) </p> */}
                          <i
                            className="fa fa-times mr-3 mt-2"
                            data-toggle="modal"
                            data-target="#popupForChangeTime"
                          ></i>
                        </div>
                      </div>

                      <div class="modal-body">
                        <ChangeTime
                          timeTable={classTimeTable}
                          changeTimeTableFunc={changeTimeTableFunc}
                          updateTimeTableFunc={updateTimeTableFunc}
                          submitLoading={submitLoading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modalForZoomLink">
                <div
                  class="modal fade"
                  tabindex="-1"
                  role="dialog"
                  id="ModalNotTakeClass"
                  data-backdrop="static"
                  data-keyboard="false"
                >
                  <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                      <div class="">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div className="text-left">
                          <label className="font-weight-bold">Who wants to cancel? </label>
                          <div className="p-3">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                checked={reasonSelect === 1}
                                // onChange={(e) => addReasons(e, 1)}
                                onChange={(e) => setreasonSelect(1)}
                                type="radio"
                                name={""}
                                value="Because of electricity breakdown"
                              />
                              <label className="form-check-label" for="inlineRadio1">
                                I want to cancel the class:
                              </label>
                            </div>
                            {reasonSelect == 1 ? (
                              <div
                                className=""
                                style={{
                                  marginLeft: "40px",
                                  marginTop: "10px",
                                }}
                              >
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    onChange={(e) => addReasons(e, 1, 1)}
                                    type="checkbox"
                                    name={""}
                                    value="Because of electricity breakdown"
                                  />
                                  <label className="form-check-label" for="inlineRadio1">
                                    Because of electricity breakdown
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    onChange={(e) => addReasons(e, 2, 1)}
                                    type="checkbox"
                                    name={""}
                                    value="Because of health issues"
                                  />
                                  <label className="form-check-label" for="inlineRadio1">
                                    Because of health issues
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    onChange={(e) => addReasons(e, 3, 1)}
                                    type="checkbox"
                                    name={""}
                                    value="Because of a minor emergency"
                                  />
                                  <label className="form-check-label" for="inlineRadio1">
                                    Because of a minor emergency
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    onChange={(e) => addReasons(e, 4, 1)}
                                    type="checkbox"
                                    name={""}
                                    value="Because of internet outage"
                                  />
                                  <label className="form-check-label" for="inlineRadio1">
                                    Because of internet outage
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    onChange={(e) => addReasons(e, 5, 1)}
                                    type="checkbox"
                                    name={""}
                                    value="Because of death in the family"
                                  />
                                  <label className="form-check-label" for="inlineRadio1">
                                    Because of death in the family
                                  </label>
                                </div>
                              </div>
                            ) : null}

                            <div className="form-check mt-2">
                              <input
                                className="form-check-input"
                                checked={reasonSelect === 2}
                                onChange={(e) => addReasons(e, 6, 2)}
                                // onChange={(e) => setreasonSelect(2)}
                                type="radio"
                                name={""}
                                value="Because Parent wants to cancel the class"
                              />
                              <label className="form-check-label" for="inlineRadio1">
                                Parent wants to cancel the class
                              </label>
                            </div>
                            <div className="form-check mt-2">
                              <input
                                className="form-check-input"
                                checked={reasonSelect === 3}
                                onChange={(e) => addReasons(e, 7, 3)}
                                // onChange={(e) => setreasonSelect(3)}
                                type="radio"
                                name={""}
                                value="Because Local/Federal Government wants to cancel class
                                because of Public Holiday"
                              />
                              <label className="form-check-label" for="inlineRadio1">
                                Local/Federal Government wants to cancel class because of Public
                                Holiday
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          disabled={btnLoader}
                          className="btn btn-success btn-sm"
                          onClick={() => submitReasons()}
                        >
                          Notify Parent
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal fade" tabindex="-1" role="dialog" id="modalForSendPlanner">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                  <div class="modal-content">
                    <div class="p-2">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <SendTopicsStartsClass
                        plannerDataForHistory={plannerDataForHistory}
                        plannerData={plannerData}
                        updateVideoLabel={updateVideoLabel}
                        getPLannerDetails={getPLannerDetails}
                        classTime={classTime}
                        submitPlannerHistory={submitPlannerHistory}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {copied ? (
                <div
                  style={{
                    background: "#bcfda3",
                    color: "#4c844c",
                    padding: "5px 20px",
                  }}
                >
                  <label>
                    <i className="fas fa-check mr-2"></i> Zoom link Copied!
                  </label>
                </div>
              ) : null}
              <div className="history">
                {!loading ? (
                  apiError === "" ? (
                    <div className="d-flex justify-content-between">
                      <div className="">
                        {/* <label className="text-3xl font-bold underline">Hello Tailwind</label> */}
                        <h5>
                          Starts at {classStartData.start}{" "}
                          {moment(classStartData.datetime).format("ll")}
                        </h5>
                        {zoomLink && zoomLink != "null" ? (
                          <label className="" style={{ color: "#c1c1c1" }}>
                            {" "}
                            <i className="fas fa-clipboard"></i>{" "}
                            <label
                              style={{ cursor: "pointer" }}
                              className="text-primary cursor-pointer"
                              onClick={() => copyZoomLink()}
                            >
                              Copy
                            </label>{" "}
                            <span className="">Zoom link</span> &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                            <i className="fas fa-edit"></i>{" "}
                            <label
                              data-toggle="modal"
                              data-target="#myModal"
                              style={{ cursor: "pointer" }}
                              className="text-primary cursor-pointer"
                            >
                              Edit
                            </label>{" "}
                            <span className="">Zoom Link</span>
                          </label>
                        ) : (
                          <label className="" style={{ color: "#c1c1c1" }}>
                            {" "}
                            <i className="fa fa-plus-circle text-danger"></i>{" "}
                            <label
                              data-toggle="modal"
                              data-target="#myModal"
                              style={{ cursor: "pointer" }}
                              className="text-danger font-weight-bold cursor-pointer"
                            >
                              Add
                            </label>{" "}
                            <span className="">Zoom link</span>{" "}
                          </label>
                        )}
                      </div>
                      <div className="">
                        <div className="text-center">
                          {startButton && <label className="mb-0">{timerComponents}</label>}
                          <br />
                          <button
                            className={
                              startButton
                                ? "btn btn-success btn-lg disabled"
                                : "btn btn-success btn-lg notDisabled"
                            }
                            onClick={postTime}
                            disabled={startButton}
                          >
                            Start Class
                          </button>{" "}
                          <div className="marginOnMobile">
                            <label
                              className="text-primary"
                              data-toggle="modal"
                              data-target="#popupForChangeTime"
                              style={{ cursor: "pointer" }}
                            >
                              Change
                            </label>
                            <span className="text-muted"> Time</span>
                            <span className="text-muted mb-0 ml-2">or </span>
                            <label
                              className="text-danger"
                              data-toggle="modal"
                              data-target="#ModalNotTakeClass"
                              style={{ cursor: "pointer" }}
                            >
                              Cancel
                            </label>
                            <span className="text-muted"> Class</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center mb-5">
                      {/* <i className="far fa-meh fa-2x" /> <br />{" "} */}
                      <label className="font-weight-bold">{apiError}</label>
                      <br />
                      {apiError.includes("Class started") && (
                        <label className="text-muted">
                          You can make changes to the class after it is ended
                        </label>
                      )}
                    </div>
                  )
                ) : (
                  <div className="text-center">
                    {" "}
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>{" "}
                  </div>
                )}
                <h5 className="mt-3">What are you teaching today?</h5>
                <div id="accordionForTeacherManagement" class="">
                  <div className="table-responsive">
                    <table className="table table-md">
                      <tr className="font-weight-bold d-flex">
                        <th className="col-md-1" scope="row"></th>
                        <td className="col-md-5">
                          Topics from{" "}
                          <select
                            onChange={(e) => getPLannerDetails(e.target.value)}
                            style={{ border: "none" }}
                          >
                            <option
                              value={moment().subtract(0, "month").startOf("month").format("MMMM")}
                            >
                              {moment().subtract(0, "month").startOf("month").format("MMMM")}
                            </option>
                            <option
                              value={moment().subtract(1, "month").startOf("month").format("MMMM")}
                            >
                              {moment().subtract(1, "month").startOf("month").format("MMMM")}
                            </option>
                            <option
                              value={moment().subtract(2, "month").startOf("month").format("MMMM")}
                            >
                              {moment().subtract(2, "month").startOf("month").format("MMMM")}
                            </option>
                            <option
                              value={moment().subtract(3, "month").startOf("month").format("MMMM")}
                            >
                              {moment().subtract(3, "month").startOf("month").format("MMMM")}
                            </option>
                          </select>{" "}
                          planner
                        </td>
                        <td className="col-sm-2">
                          <i className="fas fa-question-circle" id="TooltipExampleQuestion"></i>

                          <MyToolTip
                            placement="right"
                            text="Questions"
                            target={"TooltipExampleQuestion"}
                          />
                        </td>
                        <td className="col-sm-2">
                          <i className="fas fa-video" id="TooltipExampleVideo"></i>
                          <MyToolTip
                            placement="right"
                            text="Videos"
                            target={"TooltipExampleVideo"}
                          />
                        </td>
                        <td className="col-sm-2">
                          <i className="fas fa-file-word" id="TooltipExampleWorksheet"></i>
                          <MyToolTip
                            placement="right"
                            text="Worksheets"
                            target={"TooltipExampleWorksheet"}
                          />
                        </td>
                      </tr>
                      <tbody>
                        {plannerData.length > 0 ? (
                          plannerData.map((item, index) => (
                            <>
                              <tr
                                className="collapsed d-flex onTableHover"
                                data-toggle="collapse"
                                data-target={`#One${index}`}
                                aria-expanded="true"
                                aria-controls="collapseOne"
                              >
                                <td className="col-sm-1">
                                  {" "}
                                  <input
                                    className="showOnHover"
                                    type="checkbox"
                                    onClick={(e) => selectedTopic(e, item)}
                                  />
                                  {item.history_timestamps &&
                                    JSON.parse(item.history_timestamps).length > 0 && (
                                      <span
                                        className="text-italic ml-1"
                                        style={{
                                          position: "relative",
                                          top: -2,
                                          fontSize: 12,
                                          color: "#D4FCB5",
                                        }}
                                      >
                                        <i
                                          className="fa fa-check"
                                          id={`TooltipExample${index}`}
                                        ></i>
                                        {item.history_timestamps &&
                                        JSON.parse(item.history_timestamps) ? (
                                          <MyToolTip
                                            text={
                                              JSON.parse(item.history_timestamps) &&
                                              JSON.parse(item.history_timestamps).map((item) => (
                                                <label>
                                                  {moment(item).format("ll")}
                                                  &nbsp;,&nbsp;
                                                </label>
                                              ))
                                            }
                                            // text="2 Aug , 3 Aug"
                                            target={`TooltipExample${index}`}
                                          />
                                        ) : null}
                                      </span>
                                    )}
                                </td>
                                <td className="col-sm-5">
                                  {" "}
                                  <label className="animated fadeInDown mb-0">
                                    {item.topicName}
                                  </label>
                                  <p
                                    className="text-italic"
                                    style={{ fontSize: 12, color: "#c1c1c1" }}
                                  >
                                    (Chapter: {item.chapterName})
                                  </p>
                                </td>
                                <td className="col-sm-2">{item.questions_count}</td>
                                <td className="col-sm-2">
                                  {item.videos_count}{" "}
                                  <span className="ml-1">
                                    {" "}
                                    <i
                                      className={
                                        item.videos_count > 0
                                          ? "fa fa-plus-circle uploadIcon"
                                          : "fa fa-plus-circle text-danger uploadIcon"
                                      }
                                      onClick={() => openVideoModalDetails(item)}
                                      id={`showAddVideoToolTip${index}`}
                                    ></i>
                                    <MyToolTip
                                      placement="right"
                                      text="Add Videos"
                                      target={`showAddVideoToolTip${index}`}
                                    />
                                  </span>
                                </td>
                                <td className="col-sm-2">
                                  {item.Worksheets_count}{" "}
                                  <span className="ml-1">
                                    {" "}
                                    <i
                                      className={
                                        item.Worksheets_count > 0
                                          ? "fa fa-plus-circle uploadIcon"
                                          : "fa fa-plus-circle text-danger uploadIcon"
                                      }
                                      onClick={() => openWorksheetModalDetails(item)}
                                      id={`showAddWorksheetToolTip${index}`}
                                    ></i>
                                    <MyToolTip
                                      placement="right"
                                      text="Add Worksheets"
                                      target={`showAddWorksheetToolTip${index}`}
                                    />
                                  </span>
                                  <i
                                    className="fa fa-chevron-down ml-1"
                                    style={{
                                      float: "right",
                                      color: "lightgray",
                                    }}
                                  ></i>
                                </td>
                              </tr>
                              <div
                                id={`One${index}`}
                                className="collapse accordionBox"
                                aria-labelledby="headingOne"
                                data-parent="#accordionForTeacherManagement"
                              >
                                <tr className="d-flex">
                                  <td className="col-sm-1"></td>
                                  <td className="col-sm-8">
                                    <div className="">
                                      <div className="">
                                        <div className="">
                                          <div className="">
                                            {/* <hr /> */}
                                            <label className="font-weight-bold">
                                              <i className="fas fa-file-word mr-2"></i> Share
                                              Worksheets:
                                            </label>

                                            {item.Worksheets &&
                                              item.Worksheets.map((worksheet, index2) => (
                                                <div
                                                  key={worksheet.id}
                                                  className="d-flex justify-content-between mb-2"
                                                >
                                                  <div>
                                                    <input
                                                      type="checkbox"
                                                      className="mr-2"
                                                      onClick={(e) => addWorksheet(e, worksheet)}
                                                    />
                                                    {worksheet.label}
                                                    &nbsp;
                                                    {worksheet.added_by_teacher == 1 && (
                                                      <span
                                                        style={{
                                                          fontSize: 12,
                                                          color: "#c1c1c1",
                                                        }}
                                                      >
                                                        (by {worksheet.user_name})
                                                      </span>
                                                    )}
                                                    <i
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() => updateLabel(worksheet, item)}
                                                      className="fa-solid fa-pencil ml-3"
                                                    ></i>
                                                    {/* <span
                                                        className="text-italic ml-2"
                                                        style={{
                                                          position: "relative",
                                                          top: -2,
                                                          fontSize: 12,
                                                          color: "#81fc21",
                                                        }}
                                                      >
                                                        <i
                                                          className="fa fa-check"
                                                          id="TooltipExample2"
                                                        ></i>
                                                        <MyToolTip
                                                          text="2 Aug"
                                                          target={
                                                            "TooltipExample2"
                                                          }
                                                        />
                                                      </span> */}
                                                  </div>
                                                  <div>
                                                    <button
                                                      className="play-button"
                                                      onClick={() =>
                                                        window.open(worksheet.link, "_blank")
                                                      }
                                                    >
                                                      Preview
                                                    </button>
                                                  </div>
                                                </div>
                                              ))}
                                            {/* <div className="d-flex justify-content-between mb-2">
                                              <div>
                                                <input
                                                  type="checkbox"
                                                  className="mr-2"
                                                />
                                                Table of 5{" "}
                                                <span
                                                  style={{
                                                    fontSize: 12,
                                                    color: "#c1c1c1",
                                                  }}
                                                >
                                                  (By You)
                                                </span>
                                              </div>
                                              <div>
                                                <button className="play-button">
                                                  Preview
                                                </button>
                                              </div>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                              <div>
                                                <input
                                                  type="checkbox"
                                                  className="mr-2"
                                                />
                                                Table of 6{" "}
                                                <span
                                                  style={{
                                                    fontSize: 12,
                                                    color: "#c1c1c1",
                                                  }}
                                                >
                                                  (By Miss Saima Farooq)
                                                </span>
                                              </div>
                                              <div>
                                                <button className="play-button">
                                                  Preview
                                                </button>
                                              </div>
                                            </div> */}
                                            <div>
                                              <button
                                                className="btn btn-light btn-sm"
                                                onClick={() => openWorksheetModalDetails(item)}
                                              >
                                                Add more worksheets{" "}
                                                <i className="fa fa-plus-circle"></i>
                                              </button>
                                            </div>
                                          </div>
                                          <div className="mt-4">
                                            <label className="font-weight-bold">
                                              <i className="fas fa-video mr-2"></i>
                                              Share Videos:
                                            </label>

                                            {item.videos &&
                                              item.videos.map((videos, index3) => (
                                                <div
                                                  key={videos.id}
                                                  className="d-flex justify-content-between mb-2"
                                                >
                                                  <div>
                                                    <input
                                                      type="checkbox"
                                                      className="mr-2"
                                                      onClick={(e) => addVideo(e, videos)}
                                                    />
                                                    {videos.video_caption} &nbsp;
                                                    {videos.added_by_teacher == 1 && (
                                                      <span
                                                        style={{
                                                          fontSize: 12,
                                                          color: "#c1c1c1",
                                                        }}
                                                      >
                                                        (by {videos.user_name})
                                                      </span>
                                                    )}
                                                    <i
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() => updateVideoLabel(videos, item)}
                                                      className="fa-solid fa-pencil ml-3"
                                                    ></i>
                                                  </div>
                                                  <div>
                                                    <button
                                                      className="play-button"
                                                      onClick={() =>
                                                        window.open(videos.video_url, "_blank")
                                                      }
                                                    >
                                                      Preview
                                                    </button>
                                                  </div>
                                                </div>
                                              ))}
                                            <div>
                                              <button
                                                className="btn btn-light btn-sm"
                                                onClick={() => openVideoModalDetails(item)}
                                              >
                                                Add more videos{" "}
                                                <i className="fa fa-plus-circle"></i>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="col-sm-1"></td>
                                  <td className="col-sm-2"></td>
                                </tr>
                              </div>
                            </>
                          ))
                        ) : (
                          <Link to="/TeacherDashboard/Planner">
                            <tr className="collapsed d-flex">
                              <td className="col-sm-12 text-center mt-5">
                                <label className="text-danger">
                                  No Planner Found for this month &nbsp;
                                </label>
                                <label className="" style={{ color: "#c1c1c1" }}>
                                  {" "}
                                  <i className="fa fa-plus-circle text-danger"></i>{" "}
                                  <label
                                    style={{ cursor: "pointer" }}
                                    className="text-danger font-weight-bold cursor-pointer"
                                  >
                                    Create
                                  </label>{" "}
                                  <span className="text-danger">Planner</span>{" "}
                                </label>
                              </td>
                            </tr>
                          </Link>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {plannerData.length > 0 && (
                <UpdatePlanner
                  programId={programId}
                  plannerData={updatedPlannerData}
                  setplannerData={setupdatedPlannerData}
                  updatePlannerFunc={updatePlannerFunc}
                  updatePlannerLoader={updatePlannerLoader}
                />
              )}
              <div className="history mt-2">
                <div className="mt-2">
                  <h5 className="mb-0">Class Attendance & Evaluation</h5>
                  {attendanceData.length > 0 && (
                    <label className="text-success font-weight-bold">
                      <i className="fa fa-check"></i> Attendance already marked for today
                    </label>
                  )}
                  <div className="table-responsive">
                    <table
                      class="table"
                      // style={alreadySubmitted ? { pointerEvents: "none" } : null}
                    >
                      <tr className="tableHeaderP">
                        <th className=""></th>
                        <th className="addExtrawidth">On Time</th>
                        <th className="addExtrawidth">Attentive</th>
                        <th className="">
                          Homework <br /> Completion
                        </th>
                        <th className="">
                          Classwork <br /> Completion
                        </th>
                      </tr>

                      {attendanceData.length > 0 ? (
                        <tbody>
                          {attendanceData.length > 0
                            ? attendanceData.map((item, index) => (
                                <tr
                                  key={index}
                                  // className={
                                  //   item.isPresent == 0 ? "disableFields" : null
                                  // }
                                >
                                  <th className="d-flex">
                                    {/* <input
                                    onClick={(e) =>
                                      markAttendanceFunction(e, item.id)
                                    }
                                    type="checkbox"
                                    className="mr-2"
                                  /> */}
                                    <div className="text-center">
                                      <label
                                        className={
                                          JSON.parse(item.attendance_data).isPresent
                                            ? "presentCircleClassStart"
                                            : "absentCircleClassStart"
                                        }
                                        onClick={(e) =>
                                          markAttendanceFunction(
                                            JSON.parse(item.attendance_data).isPresent
                                              ? false
                                              : true,
                                            JSON.parse(item.attendance_data).id
                                          )
                                        }
                                      ></label>
                                      {/* <br /> */}
                                      <span
                                        style={{
                                          fontSize: 12,
                                          color: "#c1c1c1",
                                        }}
                                      >
                                        {JSON.parse(item.attendance_data).isPresent
                                          ? "Present"
                                          : "Absent"}
                                      </span>
                                    </div>
                                    <div className="ml-2 d-flex">
                                      {JSON.parse(item.attendance_data).image !== null ? (
                                        <img
                                          src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${
                                            JSON.parse(item.attendance_data).image
                                          }`}
                                          alt="Avatar"
                                          className="avatarStudent"
                                        />
                                      ) : (
                                        <img
                                          src={require("../../../public/images/empty.svg")}
                                          alt="Avatar"
                                          className="avatarStudent"
                                        />
                                      )}
                                      <div>
                                        <label className="avatarMargin mb-0">
                                          {JSON.parse(item.attendance_data).name}{" "}
                                        </label>{" "}
                                        <p
                                          className="text-primary mt-0"
                                          onClick={() =>
                                            window.open(
                                              `https://feeds.lincolnmethod.com/#/${
                                                JSON.parse(item.attendance_data).id
                                              }`,
                                              "_blank"
                                            )
                                          }
                                          style={{
                                            fontSize: 12,
                                            marginLeft: 5,
                                            fontWeight: "normal",
                                            cursor: "pointer",
                                          }}
                                        >
                                          Goto Newsfeed
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                  <td
                                    className={
                                      JSON.parse(item.attendance_data).isPresent
                                        ? "addExtrawidth"
                                        : "addExtrwidth attendancedisabled"
                                    }
                                  >
                                    {" "}
                                    <div className="iconsCss">
                                      {" "}
                                      <label
                                        onClick={() =>
                                          changeState(
                                            JSON.parse(item.attendance_data).id,
                                            true,
                                            "onTime"
                                          )
                                        }
                                      >
                                        {" "}
                                        <i
                                          className={
                                            JSON.parse(item.attendance_data).onTime == true
                                              ? "smileSelect far fa-grin"
                                              : "iconsCss far fa-grin"
                                          }
                                        ></i>
                                      </label>{" "}
                                      <label
                                        onClick={() =>
                                          changeState(
                                            JSON.parse(item.attendance_data).id,
                                            false,
                                            "onTime"
                                          )
                                        }
                                      >
                                        {" "}
                                        <i
                                          className={
                                            JSON.parse(item.attendance_data).onTime !== ""
                                              ? JSON.parse(item.attendance_data).onTime == false
                                                ? "far fa-meh sadSelect"
                                                : "far fa-meh"
                                              : "far fa-meh"
                                          }
                                        ></i>
                                      </label>
                                    </div>
                                  </td>
                                  <td
                                    className={
                                      JSON.parse(item.attendance_data).isPresent
                                        ? "addExtrawidth"
                                        : "addExtrwidth attendancedisabled"
                                    }
                                  >
                                    {" "}
                                    <div className="iconsCss">
                                      {" "}
                                      <label
                                        onClick={() =>
                                          changeState(
                                            JSON.parse(item.attendance_data).id,
                                            true,
                                            "attentive"
                                          )
                                        }
                                      >
                                        {" "}
                                        <i
                                          className={
                                            JSON.parse(item.attendance_data).attentive == true
                                              ? "smileSelect far fa-grin"
                                              : "iconsCss far fa-grin"
                                          }
                                        ></i>
                                      </label>{" "}
                                      <label
                                        onClick={() =>
                                          changeState(
                                            JSON.parse(item.attendance_data).id,
                                            false,
                                            "attentive"
                                          )
                                        }
                                      >
                                        {" "}
                                        <i
                                          className={
                                            JSON.parse(item.attendance_data).attentive !== ""
                                              ? JSON.parse(item.attendance_data).attentive == false
                                                ? "far fa-meh sadSelect"
                                                : "far fa-meh"
                                              : "far fa-meh"
                                          }
                                        ></i>
                                      </label>
                                    </div>
                                  </td>
                                  <td
                                    className={
                                      JSON.parse(item.attendance_data).isPresent
                                        ? "addExtrawidth"
                                        : "addExtrwidth attendancedisabled"
                                    }
                                  >
                                    {" "}
                                    <div className="iconsCss">
                                      {" "}
                                      <label
                                        onClick={() =>
                                          changeState(
                                            JSON.parse(item.attendance_data).id,
                                            true,
                                            "homeworkCompletion"
                                          )
                                        }
                                      >
                                        {" "}
                                        <i
                                          className={
                                            JSON.parse(item.attendance_data).homeworkCompletion ==
                                            true
                                              ? "smileSelect far fa-grin"
                                              : "iconsCss far fa-grin"
                                          }
                                        ></i>
                                      </label>{" "}
                                      <label
                                        onClick={() =>
                                          changeState(
                                            JSON.parse(item.attendance_data).id,
                                            false,
                                            "homeworkCompletion"
                                          )
                                        }
                                      >
                                        {" "}
                                        <i
                                          className={
                                            JSON.parse(item.attendance_data).homeworkCompletion !==
                                            ""
                                              ? JSON.parse(item.attendance_data)
                                                  .homeworkCompletion == false
                                                ? "far fa-meh sadSelect"
                                                : "far fa-meh"
                                              : "far fa-meh"
                                          }
                                        ></i>
                                      </label>
                                    </div>
                                  </td>
                                  <td
                                    className={
                                      JSON.parse(item.attendance_data).isPresent
                                        ? "addExtrawidth"
                                        : "addExtrwidth attendancedisabled"
                                    }
                                  >
                                    {" "}
                                    <div className="iconsCss">
                                      {" "}
                                      <label
                                        onClick={() =>
                                          changeState(
                                            JSON.parse(item.attendance_data).id,
                                            true,
                                            "classworkCompletion"
                                          )
                                        }
                                      >
                                        {" "}
                                        <i
                                          className={
                                            JSON.parse(item.attendance_data).classworkCompletion ==
                                            true
                                              ? "smileSelect far fa-grin"
                                              : "iconsCss far fa-grin"
                                          }
                                        ></i>
                                      </label>{" "}
                                      <label
                                        onClick={() =>
                                          changeState(
                                            JSON.parse(item.attendance_data).id,
                                            false,
                                            "classworkCompletion"
                                          )
                                        }
                                      >
                                        {" "}
                                        <i
                                          className={
                                            JSON.parse(item.attendance_data).classworkCompletion !==
                                            ""
                                              ? JSON.parse(item.attendance_data)
                                                  .classworkCompletion == false
                                                ? "far fa-meh sadSelect"
                                                : "far fa-meh"
                                              : "far fa-meh"
                                          }
                                        ></i>
                                      </label>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            : null}
                        </tbody>
                      ) : (
                        <tbody>
                          {evaluationData.length > 0
                            ? evaluationData.map((item, index) => (
                                <tr
                                  key={index}
                                  // className={
                                  //   item.isPresent == 0 ? "disableFields" : null
                                  // }
                                >
                                  <th className="d-flex">
                                    {/* <input
                                    onClick={(e) =>
                                      markAttendanceFunction(e, item.id)
                                    }
                                    type="checkbox"
                                    className="mr-2"
                                  /> */}
                                    <div className="text-center">
                                      <label
                                        className={
                                          item.isPresent
                                            ? "presentCircleClassStart"
                                            : "absentCircleClassStart"
                                        }
                                        onClick={(e) =>
                                          markAttendanceFunction(
                                            item.isPresent ? false : true,
                                            item.id
                                          )
                                        }
                                      ></label>
                                      {/* <br /> */}
                                      <span
                                        style={{
                                          fontSize: 12,
                                          color: "#c1c1c1",
                                        }}
                                      >
                                        {item.isPresent ? "Present" : "Absent"}
                                      </span>
                                    </div>
                                    <div className="ml-2 d-flex">
                                      {item.image !== null ? (
                                        <img
                                          src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.image}`}
                                          alt="Avatar"
                                          className="avatarStudent"
                                        />
                                      ) : (
                                        <img
                                          src={require("../../../public/images/empty.svg")}
                                          alt="Avatar"
                                          className="avatarStudent"
                                        />
                                      )}
                                      <div>
                                        <label className="avatarMargin mb-0">{item.name} </label>{" "}
                                        <p
                                          className="text-primary mt-0"
                                          onClick={() =>
                                            window.open(
                                              `https://feeds.lincolnmethod.com/#/${item.id}`,
                                              "_blank"
                                            )
                                          }
                                          style={{
                                            fontSize: 12,
                                            marginLeft: 5,
                                            fontWeight: "normal",
                                            cursor: "pointer",
                                          }}
                                        >
                                          Goto Newsfeed
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                  <td
                                    className={
                                      item.isPresent
                                        ? "addExtrawidth"
                                        : "addExtrwidth attendancedisabled"
                                    }
                                  >
                                    {" "}
                                    <div className="iconsCss">
                                      {" "}
                                      <label onClick={() => changeState(item.id, true, "onTime")}>
                                        {" "}
                                        <i
                                          className={
                                            item.onTime == true
                                              ? "smileSelect far fa-grin"
                                              : "iconsCss far fa-grin"
                                          }
                                        ></i>
                                      </label>{" "}
                                      <label onClick={() => changeState(item.id, false, "onTime")}>
                                        {" "}
                                        <i
                                          className={
                                            item.onTime !== ""
                                              ? item.onTime == false
                                                ? "far fa-meh sadSelect"
                                                : "far fa-meh"
                                              : "far fa-meh"
                                          }
                                        ></i>
                                      </label>
                                    </div>
                                  </td>
                                  <td
                                    className={
                                      item.isPresent
                                        ? "addExtrawidth"
                                        : "addExtrwidth attendancedisabled"
                                    }
                                  >
                                    {" "}
                                    <div className="iconsCss">
                                      {" "}
                                      <label
                                        onClick={() => {
                                          changeState(item.id, true, "attentive");
                                        }}
                                      >
                                        {" "}
                                        <i
                                          className={
                                            item.attentive == true
                                              ? "smileSelect far fa-grin"
                                              : "iconsCss far fa-grin"
                                          }
                                        ></i>
                                      </label>{" "}
                                      <label
                                        onClick={() => changeState(item.id, false, "attentive")}
                                      >
                                        {" "}
                                        <i
                                          className={
                                            item.attentive !== ""
                                              ? item.attentive == false
                                                ? "far fa-meh sadSelect"
                                                : "far fa-meh"
                                              : "far fa-meh"
                                          }
                                        ></i>
                                      </label>
                                    </div>
                                  </td>
                                  <td
                                    className={
                                      item.isPresent
                                        ? "addExtrawidth"
                                        : "addExtrwidth attendancedisabled"
                                    }
                                  >
                                    {" "}
                                    <div className="iconsCss">
                                      {" "}
                                      <label
                                        onClick={() =>
                                          changeState(item.id, true, "homeworkCompletion")
                                        }
                                      >
                                        {" "}
                                        <i
                                          className={
                                            item.homeworkCompletion == true
                                              ? "smileSelect far fa-grin"
                                              : "iconsCss far fa-grin"
                                          }
                                        ></i>
                                      </label>{" "}
                                      <label
                                        onClick={() =>
                                          changeState(item.id, false, "homeworkCompletion")
                                        }
                                      >
                                        {" "}
                                        <i
                                          className={
                                            item.homeworkCompletion !== ""
                                              ? item.homeworkCompletion == false
                                                ? "far fa-meh sadSelect"
                                                : "far fa-meh"
                                              : "far fa-meh"
                                          }
                                        ></i>
                                      </label>
                                    </div>
                                  </td>
                                  <td
                                    className={
                                      item.isPresent
                                        ? "addExtrawidth"
                                        : "addExtrwidth attendancedisabled"
                                    }
                                  >
                                    {" "}
                                    <div className="iconsCss">
                                      {" "}
                                      <label
                                        onClick={() =>
                                          changeState(item.id, true, "classworkCompletion")
                                        }
                                      >
                                        {" "}
                                        <i
                                          className={
                                            item.classworkCompletion == true
                                              ? "smileSelect far fa-grin"
                                              : "iconsCss far fa-grin"
                                          }
                                        ></i>
                                      </label>{" "}
                                      <label
                                        onClick={() =>
                                          changeState(item.id, false, "classworkCompletion")
                                        }
                                      >
                                        {" "}
                                        <i
                                          className={
                                            item.classworkCompletion !== ""
                                              ? item.classworkCompletion == false
                                                ? "far fa-meh sadSelect"
                                                : "far fa-meh"
                                              : "far fa-meh"
                                          }
                                        ></i>
                                      </label>
                                    </div>
                                  </td>
                                  {/* <td className="col-3"> <div className="iconsCss"> <label className={item.onTime == true ? "smileSelect" : "iconsCss"} onClick={() => changeState(item.id, true, "onTime")}> <i className="far fa-grin"></i></label><label className="countOnTime">29</label> <label onClick={() => changeState(item.id, false, "onTime")}> <i className={item.onTime !== "" ? item.onTime == false ? "far fa-meh sadSelect" : "far fa-meh" : "far fa-meh"}></i></label><label className="countOfNotTime">19</label></div></td>
                                        <td className="col-3"> <div className="iconsCss"> <label className={item.attentive == true ? "smileSelect" : "iconsCss"} onClick={() => changeState(item.id, true, "attentive")}> <i className="far fa-grin"></i></label><label className="countOnTime">29</label> <label onClick={() => changeState(item.id, false, "attentive")}> <i className={item.attentive !== "" ? item.attentive == false ? "far fa-meh sadSelect" : "far fa-meh" : "far fa-meh"}></i></label><label className="countOfNotTime">19</label></div></td>
                                        <td className="col-3"> <div className="iconsCss"> <label className={item.workCompletion == true ? "smileSelect" : "iconsCss"} onClick={() => changeState(item.id, true, "workCompletion")}> <i className="far fa-grin"></i></label><label className="countOnTime">29</label> <label onClick={() => changeState(item.id, false, "workCompletion")}> <i className={item.workCompletion !== "" ? item.workCompletion == false ? "far fa-meh sadSelect" : "far fa-meh" : "far fa-meh"}></i></label><label className="countOfNotTime">19</label></div></td> */}
                                </tr>
                              ))
                            : null}
                        </tbody>
                      )}
                    </table>
                  </div>
                  {attendanceData.length == 0 && (
                    <div className="text-right">
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => submitEvaluation(0)}
                        disabled={disableButton}
                      >
                        Mark Attendance <i className="fas fa-paper-plane"></i>{" "}
                        {submitLoading && (
                          <div class="spinner-border spinner-border-sm" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        )}
                      </button>
                    </div>
                  )}
                  <DemoStudentEvaluation
                    clientId={1}
                    programId={1}
                    teacherId={1}
                    evaluationData={evaluationData}
                  />
                </div>
              </div>
            </div>
            {selectedPlannerTopic.length > 0 ? (
              <div className="col-md-4 simulatorForClassStart">
                {" "}
                <Simulator
                  simulatorBtn={simulatorBtn}
                  startButton={startButton}
                  programId={programId}
                  slotId={props.programNameState.slotId}
                  courseId={courseId}
                  plannerId={plannerId}
                  selectedPlannerTopic={selectedPlannerTopic}
                />{" "}
              </div>
            ) : null}
            <div className="col-md-12 mt-2">
              <div className="history">
                <div className="d-flex justify-content-between">
                  <h5>Class History</h5>
                  <select
                    className="form-select ml-2"
                    name="year"
                    style={{ borderRadius: 5 }}
                    onChange={historyFilter}
                    value={filter}
                  >
                    <option value="week">This Week</option>
                    <option value="month">This Month</option>
                    <option value="all">All</option>
                  </select>
                </div>
                <hr />
                <div id="accordionForClassHistory" className="historyRow">
                  {timeStampHistory.length
                    ? timeStampHistory.map((item, index) => (
                        <>
                          <div
                            className="historyBox"
                            data-toggle="collapse"
                            data-target={`#One11${index}`}
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            {item.label === 1 ? (
                              <div className="d-flex">
                                <div>
                                  <span className="lineOnTime"></span>
                                </div>
                                <div>
                                  <label>
                                    {item.timestamped} class started{" "}
                                    <span className="onTime">on time</span>. Added{" "}
                                    <span className="onTime">
                                      {JSON.parse(item.feed_data)?.planner_topic?.length > 0 ? (
                                        JSON.parse(item.feed_data)?.planner_topic?.length
                                      ) : (
                                        <span className="text-danger font-weight-bold"> 0 </span>
                                      )}
                                    </span>{" "}
                                    Topics,{" "}
                                    <span className="onTime">
                                      {getWorksheetsCount(item.feed_data)}
                                    </span>{" "}
                                    Worksheets,{" "}
                                    <span className="onTime">{getVideosCount(item.feed_data)}</span>{" "}
                                    Videos. Class evaluated
                                    {item.attendance.length ? (
                                      <span className="onTime">&nbsp;Yes</span>
                                    ) : (
                                      <span className="late">&nbsp;No</span>
                                    )}
                                  </label>
                                </div>
                                {item.attendance.length === 0 ||
                                getVideosCountNumber(item.feed_data) === 0 ||
                                getWorksheetsCountNumber(item.feed_data) === 0 ||
                                JSON.parse(item.feed_data)?.planner_topic?.length === 0 ? (
                                  <div className="d-flex ml-auto">
                                    <div
                                      className="px-3 py-2"
                                      style={{
                                        float: "right",
                                        height: "40px",
                                        background: "orange",
                                      }}
                                    >
                                      <i className="fa fa-dollar-sign text-light"></i>
                                    </div>
                                    <div className="">
                                      <i
                                        className="fa fa-chevron-down ml-1 mr-2 mt-3"
                                        style={{
                                          color: "lightgray",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="d-flex ml-auto">
                                    <div
                                      className="px-3 py-2"
                                      style={{
                                        float: "right",
                                        height: "40px",
                                        background: "#0dad6b",
                                      }}
                                    >
                                      <i className="fa fa-dollar-sign text-light"></i>
                                    </div>
                                    <div className="">
                                      <i
                                        className="fa fa-chevron-down ml-1 mr-2 mt-3"
                                        style={{
                                          color: "lightgray",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                )}
                              </div>
                            ) : item.label === 2 ? (
                              <div className="d-flex">
                                <div>
                                  <span className="lineLate"></span>
                                </div>
                                <div>
                                  <label>
                                    {item.timestamped} class started{" "}
                                    <span className="late">late by {item.diff_time} mins.</span>
                                    &nbsp;Added
                                    <span className="onTime">
                                      &nbsp;
                                      {JSON.parse(item.feed_data)?.planner_topic?.length > 0 ? (
                                        JSON.parse(item.feed_data)?.planner_topic?.length
                                      ) : (
                                        <span className="text-danger font-weight-bold">0</span>
                                      )}
                                    </span>{" "}
                                    Topics,{" "}
                                    <span className="onTime">
                                      {getWorksheetsCount(item.feed_data)}
                                    </span>{" "}
                                    Worksheets,{" "}
                                    <span className="onTime">{getVideosCount(item.feed_data)}</span>{" "}
                                    Videos. Class evaluated
                                    {item.attendance.length > 0 ? (
                                      <span className="onTime">&nbsp;Yes</span>
                                    ) : (
                                      <span className="late">&nbsp;No</span>
                                    )}
                                  </label>
                                </div>
                                {item.attendance.length === 0 ||
                                getVideosCountNumber(item.feed_data) === 0 ||
                                getWorksheetsCountNumber(item.feed_data) === 0 ||
                                JSON.parse(item.feed_data)?.planner_topic?.length === 0 ? (
                                  <div className="d-flex ml-auto">
                                    <div
                                      className="px-3 py-2"
                                      style={{
                                        float: "right",
                                        height: "40px",
                                        background: "orange",
                                      }}
                                    >
                                      <i className="fa fa-dollar-sign text-light"></i>
                                    </div>
                                    <div className="">
                                      <i
                                        className="fa fa-chevron-down ml-1 mr-2 mt-3"
                                        style={{
                                          color: "lightgray",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="d-flex ml-auto">
                                    <div
                                      className="px-3 py-2"
                                      style={{
                                        float: "right",
                                        height: "40px",
                                        background: "#0dad6b",
                                      }}
                                    >
                                      <i className="fa fa-dollar-sign text-light"></i>
                                    </div>
                                    <div className="">
                                      <i
                                        className="fa fa-chevron-down ml-1 mr-2 mt-3"
                                        style={{
                                          color: "lightgray",
                                        }}
                                      ></i>
                                    </div>
                                  </div>
                                )}
                              </div>
                            ) : item.label === 3 ? (
                              <React.Fragment>
                                <span className="lineMissed"></span>
                                <label>
                                  {item.timestamped} class <span className="missed">missed</span>
                                </label>
                              </React.Fragment>
                            ) : item.label === 4 ? (
                              <React.Fragment>
                                <span className="lineForgot"></span>
                                <label>
                                  {item.timestamped} class <span className="forgot">forgot</span>{" "}
                                </label>
                              </React.Fragment>
                            ) : item.label === 0 ? (
                              <div className="d-flex">
                                <div>
                                  <span className="lineLate"></span>
                                </div>
                                <div>
                                  <label>
                                    {item.timestamped}{" "}
                                    <span className="late">class was not started</span>
                                  </label>
                                </div>
                                <div className="d-flex ml-auto">
                                  <div
                                    className="px-3 py-2"
                                    style={{
                                      float: "right",
                                      height: "40px",
                                      background: "red",
                                    }}
                                  >
                                    <i className="fa fa-dollar-sign text-light"></i>
                                  </div>
                                  <div className="">
                                    <i
                                      className="fa fa-chevron-down ml-1 mr-2 mt-3"
                                      style={{
                                        color: "lightgray",
                                      }}
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </div>
                          <div
                            id={`One11${index}`}
                            className="collapse accordionBox"
                            aria-labelledby="headingOne"
                            data-parent="#accordionForClassHistory"
                          >
                            <div className="row">
                              <div className="col-md-12">
                                <div>
                                  <div className="simulatorBox">
                                    <div className="directoryBorder animated fadeInDown">
                                      {JSON.parse(item.feed_data).planner_topic?.length > 0 ? (
                                        <>
                                          <label
                                            className="font-weight-bold"
                                            style={{ fontSize: 18 }}
                                          >
                                            Daily planner details:
                                          </label>
                                          <br />
                                          <label>Topic(s) covered in class today:</label>
                                        </>
                                      ) : (
                                        <div className="mt-4">
                                          <label className="text-danger" style={{ fontSize: 18 }}>
                                            No planner was sent <i className="fa fa-meh fa-2x" />
                                          </label>
                                        </div>
                                      )}
                                      <br />
                                      {JSON.parse(item.feed_data).planner_topic &&
                                        JSON.parse(item.feed_data).planner_topic.map(
                                          (planner, index) => (
                                            <>
                                              <div className="ml-2">
                                                <div className="d-flex">
                                                  <i className="fa fa-commenting mr-2 text-success fa-2x"></i>
                                                  <div>
                                                    <label className="mb-0">
                                                      {planner.topicName}
                                                    </label>
                                                    <p
                                                      className="text-italic ml-2"
                                                      style={{
                                                        fontSize: 12,
                                                        color: "#c1c1c1",
                                                      }}
                                                    >
                                                      (Chapter: {planner.chapterName})
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                              {planner.worksheet.length > 0 && (
                                                <label>Worksheet(s):</label>
                                              )}
                                              {planner.worksheet.map((worksheet, index2) => (
                                                <div style={{ lineHeight: 1 }}>
                                                  <label className="mb-0 animated fadeInDown">
                                                    <Media
                                                      width={20}
                                                      height={20}
                                                      object
                                                      src={worksheetIcon}
                                                      alt={worksheetIcon}
                                                    />
                                                    <label className="onHover">
                                                      {worksheet.label}
                                                    </label>
                                                  </label>
                                                </div>
                                              ))}
                                              {planner.videos.length > 0 && (
                                                <label className="mt-3">Watch Video(s):</label>
                                              )}

                                              {planner.videos.map((video, index3) => (
                                                <div style={{ lineHeight: 1 }}>
                                                  <label className="mb-0 animated fadeInDown">
                                                    <Media
                                                      width={20}
                                                      height={20}
                                                      object
                                                      src={yTubeIcon}
                                                      alt={yTubeIcon}
                                                    />
                                                  </label>
                                                  <label className="onHover">
                                                    {video.video_caption}
                                                  </label>
                                                </div>
                                              ))}
                                            </>
                                          )
                                        )}
                                    </div>
                                  </div>
                                  {item.label !== 0 && item.updateFeed === 1 && (
                                    <div className="p-3">
                                      <button
                                        className="btn btn-sm btn-success"
                                        data-toggle="modal"
                                        data-target="#modalForSendPlanner"
                                        onClick={() => openSendMoreTopics(item)}
                                      >
                                        Send More Topics?
                                      </button>
                                    </div>
                                  )}
                                  <hr />
                                  {item.attendance.length && item.attendance.length ? (
                                    <div>
                                      <label
                                        className="font-weight-bold mt-2"
                                        style={{ fontSize: 18 }}
                                      >
                                        Attendance & Evaluation:
                                      </label>
                                      <div className="table-responsive">
                                        <table class="table">
                                          <tr className="tableHeaderP">
                                            <th className=""></th>
                                            <th className="addExtrawidth">On Time</th>
                                            <th className="addExtrawidth">Attentive</th>
                                            <th className="">
                                              Homework <br /> Completion
                                            </th>
                                            <th className="">
                                              Classwork <br /> Completion
                                            </th>
                                          </tr>

                                          {item.attendance.length > 0 ? (
                                            <tbody>
                                              {item.attendance.length > 0
                                                ? item.attendance &&
                                                  item.attendance.map(
                                                    (item, index) =>
                                                      item.attendance && (
                                                        <tr key={index}>
                                                          <th className="d-flex">
                                                            <div className="text-center">
                                                              <label
                                                                className={
                                                                  JSON.parse(item.attendance)
                                                                    .isPresent
                                                                    ? "presentCircleClassStart"
                                                                    : "absentCircleClassStart"
                                                                }
                                                                onClick={(e) =>
                                                                  markAttendanceFunction(
                                                                    JSON.parse(item.attendance)
                                                                      .isPresent
                                                                      ? false
                                                                      : true,
                                                                    JSON.parse(item.attendance).id
                                                                  )
                                                                }
                                                              ></label>
                                                              <span
                                                                style={{
                                                                  fontSize: 12,
                                                                  color: "#c1c1c1",
                                                                }}
                                                              >
                                                                {JSON.parse(item.attendance)
                                                                  .isPresent
                                                                  ? "Present"
                                                                  : "Absent"}
                                                              </span>
                                                            </div>
                                                            <div className="ml-2 d-flex">
                                                              {JSON.parse(item.attendance).image !==
                                                              null ? (
                                                                <img
                                                                  src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${
                                                                    JSON.parse(item.attendance)
                                                                      .image
                                                                  }`}
                                                                  alt="Avatar"
                                                                  className="avatarStudent"
                                                                />
                                                              ) : (
                                                                <img
                                                                  src={require("../../../public/images/empty.svg")}
                                                                  alt="Avatar"
                                                                  className="avatarStudent"
                                                                />
                                                              )}
                                                              <div>
                                                                <label className="avatarMargin mb-0">
                                                                  {JSON.parse(item.attendance).name}{" "}
                                                                </label>{" "}
                                                                <p
                                                                  className="text-primary mt-0"
                                                                  onClick={() =>
                                                                    window.open(
                                                                      `https://feeds.lincolnmethod.com/#/${
                                                                        JSON.parse(item.attendance)
                                                                          .id
                                                                      }`,
                                                                      "_blank"
                                                                    )
                                                                  }
                                                                  style={{
                                                                    fontSize: 12,
                                                                    marginLeft: 10,
                                                                    fontWeight: "normal",
                                                                    cursor: "pointer",
                                                                  }}
                                                                >
                                                                  Goto Newsfeed
                                                                </p>
                                                              </div>
                                                            </div>
                                                          </th>
                                                          <td
                                                            className={
                                                              JSON.parse(item.attendance).isPresent
                                                                ? "addExtrawidth"
                                                                : "addExtrwidth attendancedisabled"
                                                            }
                                                          >
                                                            {" "}
                                                            <div className="iconsCss">
                                                              {" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    JSON.parse(item.attendance).id,
                                                                    true,
                                                                    "onTime"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    JSON.parse(item.attendance)
                                                                      .onTime == true
                                                                      ? "smileSelect far fa-grin"
                                                                      : "iconsCss far fa-grin"
                                                                  }
                                                                ></i>
                                                              </label>{" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    JSON.parse(item.attendance).id,
                                                                    false,
                                                                    "onTime"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    JSON.parse(item.attendance)
                                                                      .onTime !== ""
                                                                      ? JSON.parse(item.attendance)
                                                                          .onTime == false
                                                                        ? "far fa-meh sadSelect"
                                                                        : "far fa-meh"
                                                                      : "far fa-meh"
                                                                  }
                                                                ></i>
                                                              </label>
                                                            </div>
                                                          </td>
                                                          <td
                                                            className={
                                                              JSON.parse(item.attendance).isPresent
                                                                ? "addExtrawidth"
                                                                : "addExtrwidth attendancedisabled"
                                                            }
                                                          >
                                                            {" "}
                                                            <div className="iconsCss">
                                                              {" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    JSON.parse(item.attendance).id,
                                                                    true,
                                                                    "attentive"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    JSON.parse(item.attendance)
                                                                      .attentive == true
                                                                      ? "smileSelect far fa-grin"
                                                                      : "iconsCss far fa-grin"
                                                                  }
                                                                ></i>
                                                              </label>{" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    JSON.parse(item.attendance).id,
                                                                    false,
                                                                    "attentive"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    JSON.parse(item.attendance)
                                                                      .attentive !== ""
                                                                      ? JSON.parse(item.attendance)
                                                                          .attentive == false
                                                                        ? "far fa-meh sadSelect"
                                                                        : "far fa-meh"
                                                                      : "far fa-meh"
                                                                  }
                                                                ></i>
                                                              </label>
                                                            </div>
                                                          </td>
                                                          <td
                                                            className={
                                                              JSON.parse(item.attendance).isPresent
                                                                ? "addExtrawidth"
                                                                : "addExtrwidth attendancedisabled"
                                                            }
                                                          >
                                                            {" "}
                                                            <div className="iconsCss">
                                                              {" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    JSON.parse(item.attendance).id,
                                                                    true,
                                                                    "homeworkCompletion"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    JSON.parse(item.attendance)
                                                                      .homeworkCompletion == true
                                                                      ? "smileSelect far fa-grin"
                                                                      : "iconsCss far fa-grin"
                                                                  }
                                                                ></i>
                                                              </label>{" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    JSON.parse(item.attendance).id,
                                                                    false,
                                                                    "homeworkCompletion"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    JSON.parse(item.attendance)
                                                                      .homeworkCompletion !== ""
                                                                      ? JSON.parse(item.attendance)
                                                                          .homeworkCompletion ==
                                                                        false
                                                                        ? "far fa-meh sadSelect"
                                                                        : "far fa-meh"
                                                                      : "far fa-meh"
                                                                  }
                                                                ></i>
                                                              </label>
                                                            </div>
                                                          </td>
                                                          <td
                                                            className={
                                                              JSON.parse(item.attendance).isPresent
                                                                ? "addExtrawidth"
                                                                : "addExtrwidth attendancedisabled"
                                                            }
                                                          >
                                                            {" "}
                                                            <div className="iconsCss">
                                                              {" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    JSON.parse(item.attendance).id,
                                                                    true,
                                                                    "classworkCompletion"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    JSON.parse(item.attendance)
                                                                      .classworkCompletion == true
                                                                      ? "smileSelect far fa-grin"
                                                                      : "iconsCss far fa-grin"
                                                                  }
                                                                ></i>
                                                              </label>{" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    JSON.parse(item.attendance).id,
                                                                    false,
                                                                    "classworkCompletion"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    JSON.parse(item.attendance)
                                                                      .classworkCompletion !== ""
                                                                      ? JSON.parse(item.attendance)
                                                                          .classworkCompletion ==
                                                                        false
                                                                        ? "far fa-meh sadSelect"
                                                                        : "far fa-meh"
                                                                      : "far fa-meh"
                                                                  }
                                                                ></i>
                                                              </label>
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      )
                                                  )
                                                : null}
                                            </tbody>
                                          ) : (
                                            <label>No work</label>
                                          )}
                                        </table>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <div className="mt-4 animated fadeInDown">
                                        <label className="text-danger" style={{ fontSize: 18 }}>
                                          No attendance was marked <i className="fa fa-meh fa-2x" />
                                        </label>
                                      </div>

                                      <div>
                                        <label
                                          className="font-weight-bold mt-2"
                                          style={{ fontSize: 15 }}
                                        >
                                          Mark Attendance & Evaluation for {item.timestamped}:
                                        </label>
                                        <div className="row">
                                          <div className="col-md-12">
                                            <div className="table-responsive">
                                              <table class="table">
                                                <tr className="tableHeaderP">
                                                  <th className=""></th>
                                                  <th className="addExtrawidth">On Time</th>
                                                  <th className="addExtrawidth">Attentive</th>
                                                  <th className="">
                                                    Homework <br /> Completion
                                                  </th>
                                                  <th className="">
                                                    Classwork <br /> Completion
                                                  </th>
                                                </tr>
                                                <tbody>
                                                  {evaluationData.length > 0
                                                    ? evaluationData.map((item, index) => (
                                                        <tr key={index}>
                                                          <th className="d-flex">
                                                            <div className="text-center">
                                                              <label
                                                                className={
                                                                  item.isPresent
                                                                    ? "presentCircleClassStart"
                                                                    : "absentCircleClassStart"
                                                                }
                                                                onClick={(e) =>
                                                                  markAttendanceFunction(
                                                                    item.isPresent ? false : true,
                                                                    item.id
                                                                  )
                                                                }
                                                              ></label>
                                                              <span
                                                                style={{
                                                                  fontSize: 12,
                                                                  color: "#c1c1c1",
                                                                }}
                                                              >
                                                                {item.isPresent
                                                                  ? "Present"
                                                                  : "Absent"}
                                                              </span>
                                                            </div>
                                                            <div className="ml-2 d-flex">
                                                              {item.image !== null ? (
                                                                <img
                                                                  src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${item.image}`}
                                                                  alt="Avatar"
                                                                  className="avatarStudent"
                                                                />
                                                              ) : (
                                                                <img
                                                                  src={require("../../../public/images/empty.svg")}
                                                                  alt="Avatar"
                                                                  className="avatarStudent"
                                                                />
                                                              )}
                                                              <div>
                                                                <label className="avatarMargin mb-0">
                                                                  {item.name}{" "}
                                                                </label>{" "}
                                                                <p
                                                                  className="text-primary mt-0"
                                                                  onClick={() =>
                                                                    window.open(
                                                                      `https://feeds.lincolnmethod.com/#/${item.id}`,
                                                                      "_blank"
                                                                    )
                                                                  }
                                                                  style={{
                                                                    fontSize: 12,
                                                                    marginLeft: 10,
                                                                    fontWeight: "normal",
                                                                    cursor: "pointer",
                                                                  }}
                                                                >
                                                                  Goto Newsfeed
                                                                </p>
                                                              </div>
                                                            </div>
                                                          </th>
                                                          <td
                                                            className={
                                                              item.isPresent
                                                                ? "addExtrawidth"
                                                                : "addExtrwidth attendancedisabled"
                                                            }
                                                          >
                                                            {" "}
                                                            <div className="iconsCss">
                                                              {" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    item.id,
                                                                    true,
                                                                    "onTime"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    item.onTime == true
                                                                      ? "smileSelect far fa-grin"
                                                                      : "iconsCss far fa-grin"
                                                                  }
                                                                ></i>
                                                              </label>{" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    item.id,
                                                                    false,
                                                                    "onTime"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    item.onTime !== ""
                                                                      ? item.onTime == false
                                                                        ? "far fa-meh sadSelect"
                                                                        : "far fa-meh"
                                                                      : "far fa-meh"
                                                                  }
                                                                ></i>
                                                              </label>
                                                            </div>
                                                          </td>
                                                          <td
                                                            className={
                                                              item.isPresent
                                                                ? "addExtrawidth"
                                                                : "addExtrwidth attendancedisabled"
                                                            }
                                                          >
                                                            {" "}
                                                            <div className="iconsCss">
                                                              {" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    item.id,
                                                                    true,
                                                                    "attentive"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    item.attentive == true
                                                                      ? "smileSelect far fa-grin"
                                                                      : "iconsCss far fa-grin"
                                                                  }
                                                                ></i>
                                                              </label>{" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    item.id,
                                                                    false,
                                                                    "attentive"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    item.attentive !== ""
                                                                      ? item.attentive == false
                                                                        ? "far fa-meh sadSelect"
                                                                        : "far fa-meh"
                                                                      : "far fa-meh"
                                                                  }
                                                                ></i>
                                                              </label>
                                                            </div>
                                                          </td>
                                                          <td
                                                            className={
                                                              item.isPresent
                                                                ? "addExtrawidth"
                                                                : "addExtrwidth attendancedisabled"
                                                            }
                                                          >
                                                            {" "}
                                                            <div className="iconsCss">
                                                              {" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    item.id,
                                                                    true,
                                                                    "homeworkCompletion"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    item.homeworkCompletion == true
                                                                      ? "smileSelect far fa-grin"
                                                                      : "iconsCss far fa-grin"
                                                                  }
                                                                ></i>
                                                              </label>{" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    item.id,
                                                                    false,
                                                                    "homeworkCompletion"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    item.homeworkCompletion !== ""
                                                                      ? item.homeworkCompletion ==
                                                                        false
                                                                        ? "far fa-meh sadSelect"
                                                                        : "far fa-meh"
                                                                      : "far fa-meh"
                                                                  }
                                                                ></i>
                                                              </label>
                                                            </div>
                                                          </td>
                                                          <td
                                                            className={
                                                              item.isPresent
                                                                ? "addExtrawidth"
                                                                : "addExtrwidth attendancedisabled"
                                                            }
                                                          >
                                                            {" "}
                                                            <div className="iconsCss">
                                                              {" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    item.id,
                                                                    true,
                                                                    "classworkCompletion"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    item.classworkCompletion == true
                                                                      ? "smileSelect far fa-grin"
                                                                      : "iconsCss far fa-grin"
                                                                  }
                                                                ></i>
                                                              </label>{" "}
                                                              <label
                                                                onClick={() =>
                                                                  changeState(
                                                                    item.id,
                                                                    false,
                                                                    "classworkCompletion"
                                                                  )
                                                                }
                                                              >
                                                                {" "}
                                                                <i
                                                                  className={
                                                                    item.classworkCompletion !== ""
                                                                      ? item.classworkCompletion ==
                                                                        false
                                                                        ? "far fa-meh sadSelect"
                                                                        : "far fa-meh"
                                                                      : "far fa-meh"
                                                                  }
                                                                ></i>
                                                              </label>
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      ))
                                                    : null}
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="text-right mb-4">
                                        <button
                                          onClick={() => submitEvaluation(item.ts)}
                                          disabled={disableButton}
                                          className="btn btn-success btn-sm"
                                        >
                                          Mark Attendance <i className="fas fa-paper-plane"></i>{" "}
                                          {submitLoading && (
                                            <div
                                              class="spinner-border spinner-border-sm"
                                              role="status"
                                            >
                                              <span class="sr-only">Loading...</span>
                                            </div>
                                          )}
                                        </button>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ))
                    : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    programNameState: state.feedTutorRed.programName,
    classStartTime: state.feedTutorRed.classStartTime,
    attendanceData: state.feedTutorRed.attendanceData,
  };
}
export default connect(mapStateToProps, {
  getClassStartTime,
  sendStartTime,
  getClassSummary,
  sendActions,
  submitZoomLinkForClassStart,
  submitClassCancelReasons,
  submitEvaluationReport,
  uploadVideoinTopics,
  updatePlannerDataFunc,
  updateTimeTable,
  getAllChapters,
  updatePlannerEndpoint,
})(ClassStart3);
